import React, { useEffect } from 'react';
import Application from './Application';

const ApplicationForm = () => {
  useEffect(() => {
    console.log('ApplicationForm component rendered');
  }, []);

  return <Application />;
};

export default ApplicationForm;
